import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from './api-base.token';
import { CreateOrganizationRequest, Organization, UpdateOrganizationRequest } from './models';

@Injectable({ providedIn: 'root' })
export class OrganizationsApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  list() {
    return this.http.get<Organization[]>(`${this.apiBaseUrl}/api/organizations`);
  }

  create(payload: CreateOrganizationRequest) {
    return this.http.post<Organization>(`${this.apiBaseUrl}/api/organizations`, payload);
  }

  update(id: string, payload: UpdateOrganizationRequest) {
    return this.http.patch<Organization>(`${this.apiBaseUrl}/api/organizations/${id}`, payload);
  }

  delete(id: string) {
    return this.http.delete<boolean>(`${this.apiBaseUrl}/api/organizations/${id}`);
  }
}
